import * as React from 'react';
import {observer} from 'mobx-react';
import {styled} from '../../utils';
import AirbnbRedirectButton from './private/AirbnbRedirectButton';
import AirbnbFinishRedirectVerificationButton from './private/AirbnbFinishRedirectVerificationButton';
import {AirbnbRedirectVerification} from '../../models/airbnbAuthModel';

export interface AirbnbRedirectVerificationProcedureProps {
  method: AirbnbRedirectVerification;
}

const Description = styled('h5')({
  fontWeight: 700,
  marginBottom: 15
});

@observer
export default class AirbnbRedirectVerificationProcedure extends React.Component<
  AirbnbRedirectVerificationProcedureProps,
  {}
> {
  public render() {
    const {method} = this.props;
    const {linkClicked} = method;

    return (
      <div style={{paddingBottom: 20}}>
        <Description>
          Verify by going to Airbnb website. After you verify your credentials on Airbnb website, come back to this page
          and click on "I've done it"
        </Description>

        <AirbnbRedirectButton method={method} />
        {linkClicked ? <AirbnbFinishRedirectVerificationButton method={method} /> : null}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/AirbnbRedirectVerificationProcedure/AirbnbRedirectVerificationProcedure.tsx